import canUseDOM from './canUseDOM'
import { SHARED_PATHS } from './paths'

/**
 * Get the appropriate domain for Stytch cookie configuration
 * Returns the full hostname to scope cookies to individual organization subdomains
 * This ensures each organization has its own isolated session
 * Backend API calls use Authorization headers instead of cookies
 */
export const getStytchCookieDomain = (): string => {
  // Return localhost for server-side rendering or when DOM is not available
  if (!canUseDOM) {
    return 'localhost'
  }

  const hostname = window.location.hostname

  // Handle localhost
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'localhost'
  }

  // Return the full hostname to scope cookies to individual organization subdomains
  // This ensures each organization (e.g., geha.hs-pp-317.preview.poweredbyash.io) has its own isolated session
  // Backend API calls will use Authorization headers instead of cookies for cross-domain requests
  return hostname
}

/**
 * Get the dynamic redirect URL for Stytch based on current environment
 * This ensures magic links redirect to the same environment the user is on
 *
 * Production: Returns static URL (https://poweredbyash.io/authenticate-init)
 * Dev/Preview: Returns current hostname URL for dynamic routing
 */
export const getStytchRedirectURL = (): string => {
  if (!canUseDOM) {
    return `http://localhost:3000${SHARED_PATHS.authenticateInit}`
  }

  // After #11 merges, replace with getCurrentEnvironment() === 'production'
  const isProd = /(?<!\.preview|\.staging)\.poweredbyash\.io$/.test(location.hostname)

  // In prod, Stytch doesn't support wildcard subdomain redirects
  const origin = isProd ? 'https://poweredbyash.io' : location.origin

  return `${origin}${SHARED_PATHS.authenticateInit}`
}
